import * as React from 'react';
import List from '@mui/material/List';
import MenuItem from '../components/Navigation/MenuItem';

import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import AppsIcon from '@mui/icons-material/Apps';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CodeIcon from '@mui/icons-material/Code';
import BusinessIcon from '@mui/icons-material/Business';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import BlockIcon from '@mui/icons-material/Block';
import LockIcon from '@mui/icons-material/Lock';
import KeyIcon from '@mui/icons-material/Key';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

import { authUtils } from 'utils/authUtils.js';

export default function ListItems(props) {
  const menuItemList = [
    {
      name: '사용자',
      Icon: PersonIcon,
      items: [
        {
          name: '정보관리',
          uri: '/info',
          Icon: InfoIcon,
          level: 2
        },
        authUtils.useIsManager() && {
          name: '서브 계정 관리',
          uri: '/subuser',
          Icon: PeopleIcon,
          level: 2
        },
        authUtils.useIsManager() && {
          name: '회사 관리',
          uri: '/company',
          Icon: ApartmentIcon,
          level: 2
        }
      ]
    },
    authUtils.useIsManager() && {
      name: '사용권 구매',
      uri: '/coupon2',
      Icon: CreditCardIcon
    },
    authUtils.useIsManager() && {
      name: '코드 신청',
      uri: '/active',
      Icon: CodeIcon
    },
    {
      name: '제품 목록',
      uri: '/pgmlist',
      Icon: AppsIcon
    },
    {
      name: '지오코딩',
      uri: '/geo',
      Icon: GpsFixedIcon
    },
    {
      name: '게시판',
      Icon: ListAltIcon,
      items: [
        {
          name: '공지사항',
          uri: '/notice',
          Icon: PriorityHighIcon,
          level: 2
        },
        {
          name: 'QnA',
          uri: '/qna',
          Icon: QuestionMarkIcon,
          level: 2
        },
        {
          name: 'Tips',
          uri: '/tips',
          Icon: TipsAndUpdatesIcon,
          level: 2
        },
        {
          name: '자료실',
          uri: '/reference',
          Icon: AttachFileIcon,
          level: 2
        },
        {
          name: '1:1 문의',
          uri: '/secret',
          Icon: LockIcon,
          level: 2
        }
      ]
    },
    authUtils.useIsAdmin() && {
      name: '통계조회',
      uri: '/stat',
      Icon: BarChartIcon
    },
    authUtils.useIsAdmin() && {
      name: '로그관리',
      uri: '/log',
      Icon: AssignmentIcon
    },
    {
      divider: true
    },
    authUtils.useIsAdmin() && {
      name: '대시보드',
      Icon: BarChartIcon,
      items: [
        // {
        //   name: '통합대시보드',
        //   uri: '/dashboard',
        //   Icon: InfoIcon,
        //   level: 2
        // },
        // {
        //   name: '주문정산내역',
        //   uri: '/dashboard/order-hist',
        //   Icon: ListAltIcon,
        //   level: 2
        // },
        {
          name: '매출 현황',
          uri: '/dashboard/anls-sales',
          Icon: AttachMoneyIcon,
          level: 2
        }
        // {
        //   name: 'SW 사용 현황',
        //   uri: '/dashboard/anls-sw',
        //   Icon: AppsIcon,
        //   level: 2
        // },
        // {
        //   name: '사용자 현황',
        //   uri: '/dashboard/anls-user',
        //   Icon: PeopleIcon,
        //   level: 2
        // }
      ]
    },
    {
      divider: true
    },
    authUtils.useIsAdmin() && {
      name: '관리자',
      Icon: AdminPanelSettingsIcon,
      items: [
        {
          name: '회원정보',
          uri: '/user',
          Icon: InfoIcon,
          level: 2
        },
        {
          name: '제품 관리',
          uri: '/pgm',
          Icon: InsertDriveFileIcon,
          level: 2
        },
        {
          name: 'API KEY 관리',
          uri: '/adminapikey',
          Icon: KeyIcon,
          level: 2
        },
        {
          name: 'Agent 확장자 관리',
          uri: '/filter',
          Icon: FilterAltIcon,
          level: 2
        },
        {
          name: 'TIP 관리',
          uri: '/admintip',
          Icon: LightbulbIcon,
          level: 2
        },
        {
          name: '사용권 관리',
          uri: '/admincoupon',
          Icon: CreditCardIcon,
          level: 2
        },
        {
          name: '회사 관리',
          uri: '/admincompany',
          Icon: BusinessIcon,
          level: 2
        },
        {
          name: '활성화 코드',
          uri: '/adminactive',
          Icon: CodeIcon,
          level: 2
        },
        {
          name: '차단 관리',
          uri: '/disable',
          Icon: BlockIcon,
          level: 2
        },
        {
          name: '메일 관리',
          uri: '/mail',
          Icon: MailOutlineIcon,
          level: 2
        },
        {
          name: '양식 관리',
          uri: '/form',
          Icon: InsertDriveFileIcon,
          level: 2
        }
      ]
    }
  ];

  return (
    <List component="nav" disablePadding>
      {menuItemList.map((item, index) => item && <MenuItem {...item} key={index} />)}
    </List>
  );
}
